<template>
  <div>
    <div class="credit">
      <h2 class="title-choose-photo" style="margin-bottom: 0px">
        <u>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_1'] }}</u>
      </h2>
      <p>{{ taxiCurrency }} {{ formatPrice(totalAmount) }}</p>
    </div>
    <div class="destination">
      <h2 class="title-choose-photo">
        <u>{{ lang.taxi['SFS_LANG_ROW_23'] }}</u>
      </h2>
      <div v-if="TaxiVoucherDetail.option_taxi == 3 || TaxiVoucherDetail.option_taxi == 4" class="destination-info">
        <p v-if="taxiService?.taxi_booking_detail?.length">
          {{ taxiService?.taxi_booking_detail[parseInt(indexBooking) || 0]?.to_address }}
        </p>
      </div>
      <div v-else class="destination-info">
        <p v-if="parseInt(indexBooking) != 1">{{ TaxiVoucherDetail.destination_name }}</p>
        <p v-if="taxiService?.taxi_booking_detail?.length">
          {{ taxiService?.taxi_booking_detail[parseInt(indexBooking) || 0]?.to_address }}
        </p>
      </div>
    </div>
    <div class="photo2claim-help">
      <h2 class="title-choose-photo">
        <u>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_2'] }}</u>
      </h2>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(1, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_7'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(2, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_8'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(3, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_9'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(4, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_10'] }}</span>
        </p>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- step 1 -->
    <div class="step-photo">
      <h2 class="title-choose-photo">
        <u>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_8'] }}</u>
      </h2>
      <div v-if="listPaxReceipt.length > 0">
        <div class="list-receipt">
          <div v-for="(item, k) in listPaxReceipt" :key="k" class="item-receipt mb-3">
            <div v-if="!item.remake">
              <p class="mb-2">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_11'] }}</p>
              <div class="img-item-receipt">
                <div v-if="isPdf(item.image_url)" class="pdf-container">
                  <embed class="pdf-object" :src="item.image_url" type="application/pdf" />
                </div>
                <img v-else :src="item.image_url" alt="" />
              </div>
              <div class="pt-3 receipt-amount">
                <p>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_12'] }}: {{ item.currency }} {{ item.amount }}</p>
              </div>
              <div class="btn-handle-receipt btn-handle">
                <p class="btn-handle-check" :class="listPaxReceipt.length > 1 ? 'mr-2' : ''" @click="removePicture(k)">
                  {{ lang.taxi['SFS_LANG_PHOTO2CLAIM_14'] }}
                </p>
              </div>
            </div>
          </div>
          <div class="mb-2">
            <div class="btn-take-photo">
              <button class="ws-btn add-receipt2" @click="handleClickFileUpload('receipt')">
                <i class="fas fa-plus"></i> {{ lang.taxi['SFS_LANG_PHOTO2CLAIM_15'] }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="uploadReceipt || listPaxReceipt.length == 0">
        <div class="mb-2">
          <div class="btn-take-photo">
            <button v-if="uploadReceipt || listPaxReceipt.length == 0" @click="handleClickFileUpload('receipt')">
              <i class="fas fa-camera"></i>
            </button>
            <button v-else class="ws-btn add-receipt2" @click="handleClickFileUpload('receipt')">
              <i class="fas fa-plus"></i> {{ lang.taxi['SFS_LANG_PHOTO2CLAIM_15'] }}
            </button>
          </div>
        </div>
      </div>
      <input
        id="file-receipt"
        ref="receipt"
        type="file"
        accept="image/*;capture=camera"
        style="display: none"
        @change="handleFileUpload($event, 'receipt')"
      />
    </div>
    <!-- step 2 -->
    <div v-if="showBankDetail" style="margin-bottom: 10px">
      <NewTransferWiseForm
        :wise-bank-detail="taxiInfo.bank_info"
        :lang-transfer-wise="lang.taxi"
        @updateInfoPaxBank="updateInfoPaxBank"
      />
    </div>
    <div v-if="pax.enable_ref_print_a4 == 1" class="step-photo">
      <p style="padding: 0.5rem 0" v-html="replaceStr(lang.taxi['SFS_LANG_PHOTO2CLAIM_21'], ['<airline>'], [airline.name])"></p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
import { replaceStr, isPdf } from '@/utils/helper'
import { mapGetters } from 'vuex'
import NewTransferWiseForm from '@/components/NewTransferWiseForm/Index'
import { QUOTE_NOT_SUPPORTED } from '@/constants/wise-error-code'

Vue.use(vueCountryRegionSelect)
export default {
  components: {
    NewTransferWiseForm
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    taxiInfo: {
      type: Object,
      default: () => {}
    },
    taxiPrice: {
      type: [Object, Array],
      default: () => {}
    },
    voucher: {
      type: Object,
      default: () => {}
    },
    indexBooking: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      file: '',
      idx: 0,
      enableSingleUse: 0,
      uploadReceipt: true,
      listPaxReceipt: [],
      listRemake: [],
      infoPaxBank: {},
      keyReceipt: null,
      taxiService: {},
      notifyValidSwift: false,
      totalAmount: 0,
      status_action_save: false,
      show_confirm_exceeds: false,
      text_confirm_exceeds: '',
      currencyReceipt: '',
      showBankDetail: false,
      taxiCurrency: ''
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services'
    }),
    TaxiVoucherDetail() {
      let voucherKey = Object.keys(this.voucher)[0]
      let voucherDetail = this.voucher[voucherKey]
      voucherDetail.destination_name = voucherDetail.details[0].end_point.Name || ''
      return voucherDetail
    }
  },
  watch: {
    Services: {
      handler(val) {
        this.initData()
      },
      deep: true
    },
    taxiInfo(val) {
      this.initData()
    },
    taxiPrice: {
      handler() {
        this.setTaxiPrice()
      },
      deep: true
    }
  },
  mounted() {
    if (_.find(this.Services, { service_id: 1 })) {
      this.initData()
    } else {
      this.$store.dispatch('Home/getServices')
      this.initData()
    }
  },
  methods: {
    replaceStr,
    isPdf,
    initData() {
      let self = this
      self.taxiService = _.find(self.Services, { service_id: 4 })
      if (self.taxiInfo && self.taxiInfo.bank_info) {
        if (self.taxiInfo.list_receipt && self.taxiInfo.list_receipt.length > 0) {
          self.listPaxReceipt = self.taxiInfo.list_receipt
          self.currencyReceipt = self.listPaxReceipt[0]['currency']
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.uploadReceipt = false
        }
      }
      if (!_.isEmpty(self.airline.params)) {
        self.enableSingleUse = self.airline.params.photo2claim.enable_single_use
      }
      //important: please check airport config currency first
      self.taxiCurrency = self.taxiService.currency
      self.setTaxiPrice()
    },
    setTaxiPrice() {
      const estAmount = parseFloat(this.taxiService?.taxi_booking_detail?.[this.indexBooking]?.est_amount ?? 0)

      if (Number.isFinite(estAmount) && estAmount > 0) {
        this.totalAmount = estAmount
      } else {
        this.totalAmount = 0
      }
    },
    checkSwift(e) {
      let value = e.target.value
      if (value) {
        this.notifyValidSwift = false
      }
    },
    removePicture(key) {
      this.listRemake.push(this.listPaxReceipt[key].image_path)
      _.remove(this.listPaxReceipt, function (n, k) {
        return k == key
      })
      this.currencyReceipt =
        this.listPaxReceipt.length == 0 || this.listPaxReceipt.length == this.listRemake.length ? '' : this.currencyReceipt
      this.showBankDetail = this.listPaxReceipt.length > 0 ? true : false
      this.$forceUpdate()
    },
    handleClickFileUpload(refName) {
      this.$refs[refName].click()
    },
    handleFileUpload: function (event, type) {
      if (event) {
        event.stopPropagation()
      }
      this.file = this.$refs[type].files[0]
      this.submitFile(event, type)
    },

    backToHome() {
      let secret = this.$route.query.secret
      this.$router.push({ path: '/home', query: { secret: secret } })
    },

    updateInfoPaxBank(infoPaxBank) {
      this.infoPaxBank = infoPaxBank
      this.saveInfoPax(true)
    },

    saveInfoPax(checkExceedPrice) {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0) {
        self.$swal(this.lang.taxi['SFS_LANG_PHOTO2CLAIM_17'])
        return false
      }
      let totalAmount = 0
      _.forEach(self.listPaxReceipt, function (item) {
        item.service_id = 4
        totalAmount += parseFloat(item.amount)
        item.taxiCurrency = self.taxiCurrency
      })
      if (totalAmount == 0) {
        self.$swal(this.lang.taxi['SFS_LANG_PHOTO2CLAIM_35'] || 'Unable to upload receipt with value 0, please upload other!')
        return false
      }
      self.infoPaxBank.service_id = 4 // service Taxi
      self.infoPaxBank.amount = totalAmount
      self.infoPaxBank.taxi_detail_id = self.taxiService.taxi_booking_detail[self.indexBooking].id
      let dataSend = {
        data: {
          list_receipt: self.listPaxReceipt,
          list_remake: self.listRemake,
          info_bank: self.infoPaxBank
        },
        secret: self.secret
      }
      this.$store.dispatch('Refreshment/saveInfoPax', dataSend).then((response) => {
        if (response) {
          if (!response.success) {
            if (response.message?.wsData?.errors || response.revolut_message) {
              if (response.message?.wsData?.errors?.some((error) => error.code === QUOTE_NOT_SUPPORTED)) {
                self.$swal(
                  self.lang?.taxi['SFS_LANG_TRANSFER_WISE_15'] ||
                    'Unfortunately it is not possible to transfer money to this country. Please use another bank account or go to the desk for support.'
                )
              } else {
                self.$swal(
                  self.lang?.taxi['SFS_LANG_PHOTO2CLAIM_37'] ||
                    'This account is not validated. Please retype your account details'
                )
              }
            } else {
              self.$swal('Action failed')
            }
          }
          this.$store.dispatch('Taxi/getTaxiInfo', {
            taxiDetailId: self.taxiService.taxi_booking_detail[self.indexBooking].id
          })
        }
      })
    },
    addReceipt() {
      this.uploadReceipt = true
    },
    submitFile(event, type) {
      if (!this.file) {
        return false
      }
      let max_size = 20
      if (this.airline.params && this.airline.params.klippa && this.airline.params.klippa.maximum_file_size) {
        max_size = this.airline.params.klippa.maximum_file_size
      }
      let self = this
      let fileSize = parseFloat((this.file.size / 1024 / 1024).toFixed(4))
      if (fileSize > max_size) {
        // TODO: Get it from admin configuration
        self.$swal(self.replaceStr(self.lang.taxi['SFS_LANG_PHOTO2CLAIM_20'], '<maximum_file_size>', max_size))
        this.$refs[type].value = null
        return false
      }
      let formData = new FormData()
      formData.set('secret', this.secret)
      formData.append('image', this.file)
      this.uploadReceipt = false
      // Upload file
      self.$store.dispatch('Refreshment/uploadImg', { formData }).then((response) => {
        this.$refs[type].value = null
        if (response.success) {
          let resData = response.data
          if (type == 'receipt') {
            if (!self.checkTImePurchase(resData.purchasedate, resData.purchasetime)) {
              self.$swal(self.lang.taxi['SFS_LANG_PHOTO2CLAIM_18'])
              this.listRemake.push(resData.image_path)
              return false
            }
            let receiptAdd = {
              image_url: resData.image_url,
              image_path: resData.image_path,
              merchant_name: resData.merchant_name,
              purchase_date: resData.purchasedate,
              purchase_time: resData.purchasetime,
              currency: resData.currency,
              amount: (parseFloat(resData.amount) / 100).toFixed(2),
              amount_include: (parseFloat(resData.vatamount) / 100).toFixed(2),
              taxi_detail_id: self.taxiService.taxi_booking_detail[self.indexBooking].id,
              params: JSON.stringify(resData)
            }
            if (!_.isEmpty(self.currencyReceipt) && resData.currency != self.currencyReceipt) {
              self.$swal(self.lang.taxi['SFS_LANG_PHOTO2CLAIM_16'])
              this.listRemake.push(resData.image_path)
              return false
            } else {
              self.currencyReceipt = resData.currency
            }
            let totalAmount = 0
            if (!_.isNull(self.keyReceipt)) {
              let idReceipt = _.cloneDeep(self.listPaxReceipt[self.keyReceipt].id)
              self.listPaxReceipt[self.keyReceipt] = receiptAdd
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              self.listPaxReceipt[self.keyReceipt].id = idReceipt
              self.listPaxReceipt[self.keyReceipt].remake = false
              self.keyReceipt = null
            } else {
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              totalAmount += parseFloat(receiptAdd.amount)
              self.listPaxReceipt.push(receiptAdd)
            }
            self.uploadReceipt = false
          }
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.$forceUpdate()
        } else {
          self.$swal(self.lang.taxi['SFS_LANG_PHOTO2CLAIM_19'])
        }
      })
    },
    checkTImePurchase(date, time) {
      // Config to skip check validate expiry time
      if (!this.airline.params.photo2claim.validation_check_expiry_time) {
        return true
      }

      let expire_hour = parseInt(this.airline.params.photo2claim.expire_hour || 12)
      let flightTime = this.pax.etd ? this.pax.etd : this.pax.std
      let datePurchase = this.moment(date + 'T' + time)
      let timeEnd = this.moment(flightTime).add(expire_hour, 'hours')

      return datePurchase <= timeEnd
    },
    checkReceipt() {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0 || listPaxReceiptRemake.length !== self.listPaxReceipt.length) {
        self.$swal(this.lang.taxi['SFS_LANG_PHOTO2CLAIM_17'])
        return false
      }
      return true
    },
    updateShowfield(status) {
      if (!status) {
        return false
      }
      let self = this
      let totalAmount = 0
      _.forEach(self.listPaxReceipt, function (item) {
        totalAmount += parseFloat(item.amount)
      })
      let data = {
        data: {
          source: 'EUR',
          target: self.currencyBank,
          amount: totalAmount || 10,
          form: {
            type: self.optionBank,
            details: self.infoBank
          }
        },
        secret: self.secret
      }
      self.$store.dispatch('Refreshment/updateDataField', data).then((res) => {
        self.$forceUpdate()
      })
    },

    iConClass: function (type, lang) {
      let className = ''
      switch (type) {
        case 1:
          className = lang.taxi['SFS_LANG_PHOTO2CLAIM_3'] ? lang.taxi['SFS_LANG_PHOTO2CLAIM_3'] : 'fas fa-shopping-basket'
          break
        case 2:
          className = lang.taxi['SFS_LANG_PHOTO2CLAIM_4'] ? lang.taxi['SFS_LANG_PHOTO2CLAIM_4'] : 'fas fa-camera'
          break
        case 3:
          className = lang.taxi['SFS_LANG_PHOTO2CLAIM_5'] ? lang.taxi['SFS_LANG_PHOTO2CLAIM_5'] : 'far fa-credit-card'
          break
        case 4:
          className = lang.taxi['SFS_LANG_PHOTO2CLAIM_6'] ? lang.taxi['SFS_LANG_PHOTO2CLAIM_6'] : 'fas fa-gift'
          break
        default:
      }

      return className + ' fa-2x'
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2)
      return val.toString()
    },
    strReplace(str) {
      let self = this
      let search = ['<currency>', '<amount_total>']
      let rep = [self.taxiService.currency, self.formatPrice(self.totalAmount)]
      return self.replaceStr(str, search, rep)
    },
    handlerTextExceed(str) {
      let self = this
      let search = ['<symbol_currency>', '<amount_total>']
      let rep = [self.taxiService.symbol, self.formatPrice(self.totalAmount)]
      return self.replaceStr(str, search, rep)
    }
  }
}
</script>
<style scoped>
.pdf-container {
  width: 100%;
  height: 0;
  padding-bottom: 100%; /* Set the aspect ratio to match the page size */
  position: relative;
  overflow: hidden;
}

.pdf-object {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
